var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56582 0.191549C9.30011 0.452056 9.3001 0.884499 9.56061 1.15022L12.7284 4.32319H0.672108C0.302188 4.32319 0 4.62538 0 5.00051C0 5.37564 0.302188 5.67783 0.672108 5.67783H12.7232L9.5554 8.85081C9.29489 9.11652 9.3001 9.54375 9.56061 9.80947C9.82633 10.07 10.2484 10.07 10.5141 9.80426L14.8072 5.47984C14.8645 5.41732 14.9114 5.34959 14.9479 5.26623C14.9844 5.18287 15 5.09429 15 5.00572C15 4.82858 14.9323 4.66185 14.8072 4.5316L10.5141 0.20718C10.2588 -0.0637475 9.83154 -0.0689578 9.56582 0.191549Z",
    fill: "#3AA3B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.62aa15ea7196bb2c2c25087c915e85da.svg";
export { ForwardRef as ReactComponent };